import { ReactNode } from "react";
import { AlertasFinanceiros } from "@/components/AlertasFinanceiros";
import { SyncIndicator } from "@/components/SyncIndicator";

interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  leftActions?: ReactNode;
  rightActions?: ReactNode;
  showStatusIndicators?: boolean;
  statusIndicatorsAbove?: boolean;
}

export function PageHeader({
  title,
  description,
  icon,
  leftActions,
  rightActions,
  showStatusIndicators = true,
  statusIndicatorsAbove = false,
}: PageHeaderProps) {
  return (
    <header className="border-b border-border bg-gradient-to-r from-purple-50 via-pink-50 to-orange-50 backdrop-blur-sm sticky top-0 z-50 shadow-lg">
      {/* Status Indicators - Top section when statusIndicatorsAbove is true (desktop only) */}
      {showStatusIndicators && statusIndicatorsAbove && (
        <div className="hidden md:flex items-center justify-end gap-0.5 px-4 md:px-6 py-0 border-b border-border/50 scale-90 origin-right">
          <AlertasFinanceiros />
          <SyncIndicator />
        </div>
      )}

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 p-4 md:p-6">
        {/* Left: Icon + Title */}
        <div className="flex items-center gap-3 flex-1 min-w-0">
          {icon && <div className="p-2.5 bg-purple-100 rounded-lg flex-shrink-0">{icon}</div>}
          <div className="flex-1 min-w-0">
            <h1 className="text-lg md:text-xl font-bold text-foreground truncate">{title}</h1>
            {description && <p className="text-xs md:text-sm text-muted-foreground truncate">{description}</p>}
          </div>
        </div>

        {/* Right: Actions + Status Indicators */}
        <div className="flex gap-2 w-full md:w-auto items-center flex-wrap md:flex-nowrap">
          {leftActions}

          {/* Spacer to push right actions to the end */}
          <div className="flex-1 md:flex-none" />

          {/* Right actions */}
          {rightActions}

          {/* Status Indicators - Inline (default, desktop only) */}
          {showStatusIndicators && !statusIndicatorsAbove && (
            <div className="hidden md:flex items-center gap-2 md:gap-3 flex-shrink-0">
              <AlertasFinanceiros />
              <SyncIndicator />
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
